import React from 'react'
import './index.css';
import { OneStopService,
    hargaTerjangkau,
    wordlShipping, } from '../../../assets/image';
import { Container, Row, Col } from 'react-bootstrap';

const index = () => {
  return (
    <div className='why-hbu align-items-center justify-content-center'>
    <Container className='why-hbu-container '>
      <Col className='text-center'>
        
        <p className="title">Mengapa Harus <span className='thema-color'>HBUExpress</span> ?</p> 
      <p>HBUExpress adalah brand jasa Pengiriman Internasional, yang berdiri sejak tahun 2018 dibawah Perusahaan 
PT Humdi Berkah Utama dan terdaftar dalam keanggotaan ASPERINDO</p>      
      
      </Col>
     
      
      <Row className='row-content justify-content-md-center'>      
        <Col  >
        <img src={OneStopService} className='img-icon-OneStopService'/>
        
        </Col>
        <Col className='d-flex justify-content-start '>
        <ul className="list-unstyled">
          <li> <p className="title">WORLDWIDE <br/>
          <span className='thema-color'>SHIPPING ONE STOP </span> <br/>SOLUTION</p> <br/></li>
          <li><p>Di HBUExpress, kami menyediakan kemudahan bagi para pelanggan untuk membandingkan harga dan layanan dari berbagai kurir terbaik di dunia dalam satu platform. Dengan fitur ini, Anda tidak perlu lagi repot-repot memeriksa satu per satu. Kami mengerti bahwa setiap pelanggan memiliki kebutuhan yang berbeda-beda, oleh karena itu kami memberikan keuntungan bagi Anda untuk memilih kurir yang paling cocok dengan kebutuhan pengiriman Anda. Dengan HBUExpress, pengiriman menjadi lebih efisien dan efektif, membantu Anda dalam mengambil keputusan yang tepat untuk pengiriman Anda.</p>
       </li>
        </ul>
       
         </Col>
      </Row>
      {/* Center */}
      <Row className='row-content justify-content-md-center'>
        <Col  className='d-flex justify-content-end'>
        <ul className="list-unstyled">
          <li> <p className="title">HARGA LEBIH<br/>
          <span className='thema-color'>TERJANGKAU</span></p> </li>
          <li><p>HBUExpress menawarkan harga terbaik dari setiap Brand Kurir yang tersedia di platform kami. Kami memahami keinginan Anda untuk mendapatkan layanan terbaik dengan harga yang kompetitif. Dapatkan diskon hingga 60% untuk pengiriman ke berbagai destinasi sesuai dengan Brand kurir pilihan Anda, termasuk DHL, FedEx, UPS, Aramex, SF Express, dan banyak lagi.</p>
       </li>
        </ul>
        </Col>
        <Col  className='d-flex justify-content-center'>
        <img src={hargaTerjangkau} className='img-icon'/>
        </Col>
      </Row>

      <Row className='row-content justify-content-md-center'>
        <Col className='d-flex justify-content-center'>
        
        <img src={wordlShipping} className='img-icon'/>
        </Col>
        <Col className='d-flex justify-content-center'>
        <ul className="list-unstyled">
          <li> <p className="title">MENJANGKAU  <br/>
          <span className='thema-color'>SELURUH </span> <br/>DUNIA</p></li>
          <li><p>Jasa Pengiriman International HBUExpress Menjangkau Seluruh Bagian Dunia Dengan Proses Pengiriman Express (Super Cepat).</p>
       </li>
        </ul>
        </Col>
      </Row>


    </Container>

    </div>
  )
}

export default index